import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import { toast, Toaster } from "react-hot-toast";

const Form = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_3umzpbo", // Replace with your EmailJS Service ID
        "template_17q7q9k", // Replace with your EmailJS Template ID
        form.current,
        "VBM5w1WHFkfXIn3Zx" // Replace with your EmailJS Public Key
      )
      .then(
        () => {
          toast.success("🎉 Email sent successfully! We'll get back to you shortly.", {
            position: "top-right",
          });
          form.current.reset(); // Reset the form after sending
        },
        (error) => {
          console.error("Failed to send message", error.text);
          toast.error("❌ Failed to send your message. Please try again later.", {
            position: "top-right",
          });
        }
      );
  };

  return (
    <div>
      <Toaster />
      <div className="pt-10 pb-16">
      <div className="grid grid-cols-1 md:grid-cols-2">
      <div className="h-full w-full flex-1 basis-[18rem]">
            <img
              src="/images/contact/contactgif.gif"
              alt="Contact Us"
              className="w-full h-full object-cover"
            />
          </div>
        <div className="flex-1 basis-[18rem] bg-secondary py-6 !text-slate-200">
          <div className="max-w-[400px] w-full mx-auto bg-[#0a5076] p-3 rounded-lg">
            <h1 className="text-lg font-semibold">Get in touch</h1>
            <p>
              For more inquiries or deals, just conatct us using the form below,
              we will contact you back!
            </p>
           <form ref={form} onSubmit={sendEmail} className="mt-4">
                <div className="grid gap-4">
                  {/* First Name & Last Name */}
                  <div className="grid gap-4 sm:grid-cols-2">
                    <input
                      type="text"
                      name="first_name" // Matches EmailJS variable
                      className="w-full px-3 py-2 rounded-md bg-secondary text-slate-100 border border-gray-600 focus:outline-primary"
                      placeholder="First Name"
                      required
                    />
                    <input
                      type="text"
                      name="last_name" // Matches EmailJS variable
                      className="w-full px-3 py-2 rounded-md bg-secondary text-slate-100 border border-gray-600 focus:outline-primary"
                      placeholder=" Last Name"
                      required
                    />
                  </div>
                  {/* Mobile Number */}
                  <input
                    type="tel"
                    name="mobile_number"
                    className="w-full px-3 py-2 rounded-md bg-secondary text-slate-100 border border-gray-600 focus:outline-primary"
                    placeholder=" Mobile Number"
                    required
                  />
                  {/* Email */}
                  <input
                    type="email"
                    name="reply_to" // Used as "reply-to" in EmailJS
                    className="w-full px-3 py-2 rounded-md bg-secondary text-slate-100 border border-gray-600 focus:outline-primary"
                    placeholder="Email Address"
                    required
                  />
                  {/* Message */}
                  <textarea
                    name="message"
                    className="w-full px-3 py-2 rounded-md bg-secondary text-slate-100 border border-gray-600 focus:outline-primary"
                    rows={4}
                    placeholder=" Your Message"
                    required
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="w-full mt-6 px-4 py-2 text-white bg-primary rounded-md hover:bg-opacity-90 transition"
                >
                  Submit
                </button>
              </form>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Form;












// import React, { useRef } from "react";
// import emailjs from "@emailjs/browser";
// import { toast, Toaster } from "react-hot-toast";

// const Form = () => {
//   const form = useRef();

//   const sendEmail = (e) => {
//     e.preventDefault();

//     emailjs
//       .sendForm(
//         "service_3umzpbo", // Replace with your EmailJS Service ID
//         "template_17q7q9k", // Replace with your EmailJS Template ID
//         form.current,
//         "VBM5w1WHFkfXIn3Zx" // Replace with your EmailJS Public Key
//       )
//       .then(
//         () => {
//           toast.success("🎉 Email sent successfully!", {
//             position: "top-right",
//           });
//           form.current.reset(); // Reset the form after sending
//         },
//         (error) => {
//           console.error("Failed to send message", error.text);
//           toast.error("❌ Failed to send email. Please try again.", {
//             position: "top-right",
//           });
//         }
//       );
//   };

//   return (
//     <div className="pt-10 pb-8">
//       <Toaster />
//       <form ref={form} onSubmit={sendEmail}>
//         <div className="flex-col gap-4 flex-align-center sm:flex-row">
//           <div className="flex-1 w-full">
//             <p>👤 First Name</p>
//             <input
//               type="text"
//               name="first_name" // Must match the variable in EmailJS template
//               className="w-full input"
//               placeholder="Enter your first name..."
//               required
//             />
//           </div>
//           <div className="flex-1 w-full">
//             <p>👤 Last Name</p>
//             <input
//               type="text"
//               name="last_name" // Must match the variable in EmailJS template
//               className="w-full input"
//               placeholder="Enter your last name..."
//               required
//             />
//           </div>
//         </div>
//         <div className="mt-4">
//           <p>📞 Mobile Number</p>
//           <input
//             type="number"
//             name="mobile_number"
//             className="w-full input"
//             placeholder="Enter your mobile number..."
//             maxLength={10}
//             required
//           />
//         </div>
//         <div className="mt-4">
//           <p>📧 Email Address</p>
//           <input
//             type="email"
//             name="reply_to" // Used as the "reply-to" email in EmailJS
//             className="w-full input"
//             placeholder="Enter your email address..."
//             required
//           />
//         </div>
//         <div className="mt-4">
//           <p>💬 Message</p>
//           <textarea
//             rows={4}
//             name="message" // Must match the variable in EmailJS template
//             className="w-full input"
//             placeholder="Write your message here..."
//             required
//           ></textarea>
//         </div>
//         <div className="mt-4 flex-center-center">
//           <button type="submit" className="btn btn-primary">
//             🚀 Submit
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default Form;
